import './DocumentViewer.scss';

export interface DocumentViewerProps {
    url: string;
}

const DocumentViewer = ({ url }: DocumentViewerProps): JSX.Element => {
    return <iframe src={url} className="DocumentViewer" />;
};

export default DocumentViewer;
